
<div>
  <input type="file" #supportingFileDropRef [multiple]="true" [id]="'doc-ref'" hidden
    (change)="supportingFileBrowseHandler($event)" [accept]="accept" />
  <!-- accept=".pdf, .doc, .docx, .rtf, .ppt, .pptx" -->
<div  *ngIf="!isEventQuetion">
  <label [for]="'doc-ref'" appDragAndDropFileSelect
    class="btn btn-outline btn-outline-dashed text-center p-10 mb-5 w-100 bg-white"
    (fileDropped)="supportingFileDroppedHandler($event)">
    Click or Drop file in this box to upload.<br />Accepted
    formats: {{acceptLabel}}
    <!-- formats: ppt, pptx, doc, docx, pdf -->

    <br />

    <span class="badge badge-secondary badge-lg ms-2 mt-4 px-5 py-4 fs-3"><i
        class="bi bi-cloud-upload text-black fs-3"></i> Upload</span>
  </label>
  </div>
  <div *ngIf="isEventQuetion">
    <label [for]="'doc-ref'" appDragAndDropFileSelect
      class="btn btn-outline btn-outline-dashed p-5 mb-5 w-100 bg-white d-flex justify-content-between" 
      (fileDropped)="supportingFileDroppedHandler($event)">
        <div style="text-align: start !important; font-size: 12px !important;" >
          Click or Drop file in this box to upload.<br />
          Accepted formats: {{acceptLabel}}
        </div>
        <span class="badge badge-secondary ms-2 px-5 py-4 eventQuestion_File_label">
          <i class="bi bi-cloud-upload text-black fs-4"></i> Upload
        </span>
    </label>
  </div>
  
</div>
